import clsx from 'clsx';
import { Button, Loader } from 'tt-ui-lib/core';
import { EditIcon, ZoomInIcon } from 'tt-ui-lib/icons';
import styles from './FieldContainer.module.scss';
import React from 'react';

const GENERAL_TITLE = 'General Information';

const FieldContainer = ({
  children,
  title,
  isCurrentUser,
  containEditFieldButton,
  setIsEditingProfile,
  isEditingProfile,
  isLoading,
  ...restProps
}) => (
  <>
    <div
      className={clsx(
        styles.fieldContainer,
        restProps?.className,
        isEditingProfile ? styles.changedPadding : ''
      )}
    >
      <div className={styles.titleWrapper}>
        <div
          className={clsx(
            styles.title,
            title === GENERAL_TITLE && !isEditingProfile ? styles.hidden : ''
          )}
        >
          {title}
        </div>
        {containEditFieldButton && isCurrentUser && !isEditingProfile && (
          <button
            className={styles.editFieldButton}
            type="button"
            onClick={() => setIsEditingProfile(true)}
          >
            <EditIcon style={{ width: 24, height: 24 }} />
          </button>
        )}
        {isEditingProfile && restProps?.isProfBackground && (
          <button
            className={styles.editFieldButton}
            type="button"
            onClick={() => restProps?.addProf(restProps?.objKey)}
          >
            <ZoomInIcon style={{ width: 24, height: 24 }} />
          </button>
        )}
      </div>
      {children}
    </div>
    {isEditingProfile && (
      <div className={styles.editButtonsWrapper}>
        <Button
          className={styles.cancelBtn}
          type="default"
          onClick={() => setIsEditingProfile(false)}
        >
          CANCEL
        </Button>
        <Button
          disabled={isLoading}
          type="primary"
          className={styles.saveBtn}
          form={restProps?.formId}
          isSubmit
        >
          {!isLoading ? 'SAVE' : <Loader color="White" />}
        </Button>
      </div>
    )}
  </>
);

export default FieldContainer;
